import StaticSitemap from './StaticSitemap';
export default StaticSitemap;